var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17875_42330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 7.80476C4.58301 4.50665 7.45585 1.83301 10.9997 1.83301C14.5435 1.83301 17.4163 4.50665 17.4163 7.80476C17.4163 11.077 15.3684 14.8954 12.1731 16.2609C11.4282 16.5793 10.5712 16.5793 9.82628 16.2609C6.63099 14.8954 4.58301 11.077 4.58301 7.80476Z",
    stroke: "#949494",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8337 8.25033C12.8337 9.26285 12.0128 10.0837 11.0003 10.0837C9.9878 10.0837 9.16699 9.26285 9.16699 8.25033C9.16699 7.2378 9.9878 6.41699 11.0003 6.41699C12.0128 6.41699 12.8337 7.2378 12.8337 8.25033Z",
    stroke: "#949494",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2135 14.208C19.8234 14.7603 20.1663 15.3828 20.1663 16.0413C20.1663 18.3195 16.0623 20.1663 10.9997 20.1663C5.93706 20.1663 1.83301 18.3195 1.83301 16.0413C1.83301 15.3828 2.17595 14.7603 2.78585 14.208",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17875_42330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitReport);
export default __webpack_public_path__ + "static/media/visit-report.9d77c21bc8f72d0d4bc0e6530a13f172.svg";
export { ForwardRef as ReactComponent };